import type { TradingAssetsTableSort } from "@tradingApp/components/Trading/Assets/Table";
import { tradingAssetChange24h } from "@tradingApp/components/Trading/helpers/assetChange24h";
import type { TradingPerpAsset } from "@tradingApp/Providers/TradingProvider/types";

export function tradingAssetsSortByVolume(
  a: TradingPerpAsset,
  b: TradingPerpAsset,
  direction: TradingAssetsTableSort["direction"],
): number {
  const aVolume = Number.parseFloat(a.dayNtlVlm);
  const bVolume = Number.parseFloat(b.dayNtlVlm);

  return direction === "asc" ? aVolume - bVolume : bVolume - aVolume;
}

export function tradingAssetsSortByLastPrice(
  a: TradingPerpAsset,
  b: TradingPerpAsset,
  direction: TradingAssetsTableSort["direction"],
): number {
  const aPrice = Number.parseFloat(a.markPx);
  const bPrice = Number.parseFloat(b.markPx);

  return direction === "asc" ? aPrice - bPrice : bPrice - aPrice;
}

export function tradingAssetsSortByChange(
  a: TradingPerpAsset,
  b: TradingPerpAsset,
  direction: TradingAssetsTableSort["direction"],
): number {
  const { percentFormatted: percentA } = tradingAssetChange24h(a);
  const { percentFormatted: percentB } = tradingAssetChange24h(b);

  if (percentA === null || percentB === null) {
    return 0;
  }

  const aPercentNum = Number.parseFloat(percentA);
  const bPercentNum = Number.parseFloat(percentB);

  return direction === "asc"
    ? aPercentNum - bPercentNum
    : bPercentNum - aPercentNum;
}
